import React, { useState, useEffect, useContext } from 'react';
import { AccountContext } from '../Accounts'
import SideNavbar from './Sidebar';
import AccountOverview from './AccountOverview';
import AccountLoading from './AccountLoading';
import SubcriptionOverview from './SubscriptionOverview';
import TransactionsOverview from './TransactionOverview';
import { Container, AccontWrapper } from './AccountElements';
import GetStories from '../MyLibrary/getStories';
import PutStories from '../MyLibrary/putStories';
import PostRequest from './postAPIRequest';
// import { GetAccountDetails, GetMembershipStatus, GetTransactionHistory } from './api'; // These functions handle API requests to AWS S3 and Stripe
import { useNavigate } from 'react-router-dom';
import ReturnModal from '../RefundModal';

const AccountPage = () => {

    const folderPath = 'stories/';
    const [navElement, setNavElement] = useState(0);
    const [sessionStatus, setSessionStatus] = useState(false);
    const { getSession, email } = useContext(AccountContext);
    const [accountDetails, setAccountDetails] = useState({ email: '' });
    const [subscriptionDetails, setSubscriptionDetails] = useState("");
    const [productPurchases, setProductPurchases] = useState([]);
    const [transactions, setTransactions] = useState([]);
    const [loadingBoolean, setLoadingBoolean] = useState(false);
    const [status, setStatus] = useState(false);
    const [stories, setStories] = useState([]);
    const [currentPurchase, setCurrentPurchase] = useState();
    const [currentStoryId, setCurrentStoryId] = useState();
    const [returnModalOpen, setReturnModalOpen] = useState(false);
    const [updateFlag, setUpdateFlag] = useState(false);
    const navigate = useNavigate();
    const [generatingBoolean, setGeneratingBoolean] = useState(true);
    const nav = (n) => e => {
        setNavElement(n);
    };

    useEffect(() => {
        getSession()
            .then(session => {
                if (email) {
                    setAccountDetails({ email: email })
                    setSessionStatus(true)
                }
            })
            .catch(err => {
                navigate('/signin')
            });
    }, [email]);

    useEffect(() => {
        const fetchStories = async () => {
            const allStories = await GetStories(folderPath);
            // const updatedStories = allStories.map((story) => ({  All the stories I created before the implementation of the payment process do not have required removed/paidFor fields. This method sets them temporarily if needed. Can map and push using the putStories function if I want to change permenantly.
            //     ...story,
            //     removed: false,
            //     paidFor: true
            //   }));  
            setStories(allStories)
        };
        fetchStories();
    }, []);

    const checkUserStatus = async () => {
        if (sessionStatus) {
            const message = {
                'customerEmail': email
            }
            const request = {
                'requestType': 'UserStatusRequest',
                'request': JSON.stringify(message)
            }
            const response = await PostRequest(request);
            // console.log(response.subscriptionStatus.description, response.subscriptionStatus.active)
            return response
        }
        else {
            return null
        }
    }

    const handleCancelUserSubscription = async () => {
        if (sessionStatus) {
            setLoadingBoolean(true);
            const message = {
                'customerEmail': email
            }
            const request = {
                'requestType': 'CancelSubscription',
                'request': JSON.stringify(message)
            }
            const response = await PostRequest(request);
            setSubscriptionDetails(response.subscriptionStatus);
            setLoadingBoolean(false);
            return response
        }
        else {
            return null
        }
    }

    const requestRefund = async (e, intentId) => {
        e.preventDefault()
        if (sessionStatus) {
            const message = {
                'customerEmail': email,
                'paymentIntentID': intentId
            }
            const request = {
                'requestType': 'RequestRefund',
                'request': JSON.stringify(message)
            }
            const response = await PostRequest(request);
            return response
        }
        else {
            return null
        }
    };


    useEffect(() => {
        const init = async () => {
            const response = await checkUserStatus();
            // console.log(response)
            if (response) {
                setSubscriptionDetails(response.subscriptionStatus);
                setProductPurchases(response.transactionStatus.paidPurchases)
                setTransactions(response.transactionStatus.allTransactions) // TODO: Need to fix allTransactions server side such that the response object is parsable
                setGeneratingBoolean(false)
                setStatus(true);
            }
        }
        init()
    }, [sessionStatus, updateFlag]);

    // const handleChange = (e) => {
    //     const { name, value } = e.target;
    //     setAccountDetails((prev) => ({ ...prev, [name]: value }));
    // };

    const handleSave = async (e) => {
        e.preventDefault();
        // Save account details logic
    };

    const handleRemove = (storyId) => {
        // Find the single story object
        const story = stories.find(x => x.id === storyId);

        if (story) {
            console.log('updating stories');
            const updatedStory = { ...story, removed: true };

            // Update the stories list
            setStories(stories.map(x =>
                x.id === storyId ? updatedStory : x
            ));

            console.log(updatedStory.removed);

            // Update the story in the database
            PutStories(storyId, JSON.stringify(updatedStory));
        }
    };


    const isValidUUID = (uuid) => {
        const regex = /^[0-9a-f]{8}-[0-9a-f]{4}-[4][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
        return regex.test(uuid);
    };

    const handleRefundAndRemove = (e) => {
        e.preventDefault();
        requestRefund(e, currentPurchase);
        handleRemove(e, currentStoryId);
        setReturnModalOpen(false);
        setUpdateFlag(!updateFlag);
    }

    const handleReturnProcess = (e, storyId, purchaseId) => {
        e.preventDefault();
        setReturnModalOpen(true);
        setCurrentPurchase(purchaseId);
        if (isValidUUID(storyId)) {
            setCurrentStoryId(storyId)
        }
    }

    const handleCloseReturnModal = () => {
        setReturnModalOpen(false);
    }


    return (
        <>
            {status ? (
                <>
                    <Container>
                        <AccontWrapper>
                            <SideNavbar navElement={navElement} nav={nav} />
                            {navElement === 0 ? <AccountOverview accountDetails={accountDetails} /> : (
                                <>
                                    {navElement === 1 ? <SubcriptionOverview subscriptionDetails={subscriptionDetails} email={email} loadingBooling={loadingBoolean} cancelSubscription={handleCancelUserSubscription} /> : (
                                        <>
                                            {navElement === 2 ? <TransactionsOverview transactions={productPurchases} handleReturnProcess={handleReturnProcess} /> : (
                                                <>
                                                </>
                                            )
                                            }
                                        </>
                                    )
                                    }
                                </>
                            )
                            }
                        </AccontWrapper>
                    </Container>
                    <ReturnModal isOpen={returnModalOpen} onClose={() => handleCloseReturnModal()} handleReturnProcess={handleRefundAndRemove} />
                </>
            ) :
                <Container>
                    <AccontWrapper>
                        <SideNavbar navElement={navElement} nav={nav} />
                        {generatingBoolean ? (
                            <AccountLoading />
                        ) : <></>
                        }
                    </AccontWrapper>
                </Container>
            }
        </>
    )
};

export default AccountPage;
